import { connect } from 'react-redux';
import { push } from 'connected-react-router';

import { Helpers } from '../../../core/src/helpers';
import ValueProp from './value-prop';

const mapStateToProps = (state, ownProps) => {
	const { pdp, slugInfo, router } = state;
	const { pathname } = router  && router.location;
	const urlParts = Helpers.parseUrl(pathname, false, process.env.BASENAME);
	let valueProp;
	//for now check pdp seperately. Eventually it should the page component and store data in slugInfo
	if(urlParts.directory === 'pdp' && urlParts.slug === pdp.slug){
		const { pdpConfig={} } = pdp;
		const { globalValueProp={} } = pdpConfig;
		valueProp = globalValueProp.valueProp;
	}else if(slugInfo.vanityUrl === `${urlParts.dir}/${urlParts.slug}`){
		const { components={} } = slugInfo;
		const { globalValueProp={} } = components;
		valueProp = globalValueProp.valueProp;
	}

	return {
		pathname,
		valueProp
	};
}

const mapDispatchToProps = dispatch => {
	return {
		pushHistory: (pathname, queryString) => {
			dispatch(push({
				pathname: pathname,
				search: queryString
			}));
		}
	}
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ValueProp);